import { helpers } from "../../../../packages/helpers";
import {
  DEFAULT_TEXT_INPUT_HEIGHT,
  DEFAULT_FILE_LIST_HEIGHT,
  DEFAULT_DOWN_BUTTON_OFFSET,
  DEFAULT_REPLY_MESSAGE_HEIGHT,
} from "./constants";
import type { ContextState } from "./types";

const { empty } = helpers.utilities;

export const defaultState: ContextState = {
  textareaRef: null,
  textInputHeight: DEFAULT_TEXT_INPUT_HEIGHT,
  fileListHeight: DEFAULT_FILE_LIST_HEIGHT,
  replyMessageHeight: DEFAULT_REPLY_MESSAGE_HEIGHT,
  downButtonOffset: DEFAULT_DOWN_BUTTON_OFFSET,
  setFocusToInput: empty,
  handleChangeFileListHeight: empty,
  handleChangeReplyMessageHeight: empty,
};
